/**
 * @param {[string]} arrayOfStrings - as the name suggests, an array of strings
 * @param {number} limit - optional limit for the number of items to display
 * @returns {string}
 */
const arrayToCommaAnd = (arrayOfStrings = [], limit = null) => {
  if (arrayOfStrings.length <= 0) return "";
  if (limit && arrayOfStrings.length > limit) {
    const displayedItems = arrayOfStrings.slice(0, limit);
    const remainingCount = arrayOfStrings.length - limit;
    return `${displayedItems.join(", ")} and ${remainingCount} more`;
  }
  if (arrayOfStrings.length === 1) return `${arrayOfStrings[0]}`;
  if (arrayOfStrings.length === 2)
    return `${arrayOfStrings[0]} and ${arrayOfStrings[1]}`;
  return `${arrayOfStrings.slice(0, -1).join(", ")}, and ${arrayOfStrings.slice(
    -1
  )}`;
};

export default arrayToCommaAnd;
